import { render } from "./DeliverySection.vue?vue&type=template&id=5b0ab434&scoped=true"
const script = {}

import "./DeliverySection.vue?vue&type=style&index=0&id=5b0ab434&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0ab434"]])

export default __exports__